import '../new_candidate_details';
import '../public_rendering/public_page';

if (window.jQuery?.fn?.jquery && !window.jQuery.rails) {
  require('jquery-ujs');
}

if (typeof $ !== 'undefined') {
  $(() => {
    // if client include another jquery version and not jquery-ui, use default jquery version
    if ($('.datepicker').length > 0 && !$.datepicker) {
      $.noConflict();
    }

    const content = $('#content');
    const $datepicker = $('.datepicker');

    if ($datepicker.length > 0) {
      $datepicker.datepicker({ dateFormat: 'dd/mm/yy' });
    }

    if (content.length) {
      return $('.sidebar-wrapper').css('top', content.offset().top) + 24;
    }

    return undefined;
  });
}
